<template>
  <d2-container>
    <template slot="header">
      <div class="app-container calendar-list-container">
        <div class="filter-container">
          <el-collapse class="test" ref="coll">
            <el-collapse-item name="1">
              <template slot="title">
                <span style="
                    text-align: right;
                    display: inline-block;
                    width: 100px;
                    line-height: 48px;
                  ">关键字：</span>
                <el-input @keyup.enter.native="handleFilter()" style="margin: 0 10px; width: 70%" class="filter-item"
                  placeholder="案号，调解号，系统编号，批次号，当事人，卡号" v-model="listQuery.keyWord">
                </el-input>

                <el-button style="width: 5rem" class="filter-item" type="primary" round icon="search"
                  @click.stop="handleFilter()" size="small">搜索</el-button>
                <el-button style="width: 5rem" class="filter-item" type="danger" round icon="search"
                  @click.stop="resetTemp()" size="small">重置</el-button>
              </template>
              <div style="display: flex; justify-content: start">
                <div style="width: 33%; margin-top: 10px">
                  <div style="display: flex; padding: 0px" class="jfsj">
                    <span align="right" style="display: inline-block; width: 100px; line-height: 40px">立案：</span>
                    <el-select clearable v-model="listQuery.oneStepSettle" style="width: 70%; margin-left: 10px"
                      @change="handleFilter">
                      <el-option v-for="item in settleOptions" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div style="width: 33%; margin-top: 10px">
                  <div style="display: flex; padding: 0px" class="jfsj">
                    <span align="right" style="display: inline-block; width: 100px; line-height: 40px">调解/判决：</span>
                    <el-select clearable v-model="listQuery.twoStepSettle" style="width: 70%; margin-left: 10px"
                      @change="handleFilter">
                      <el-option v-for="item in settleOptions" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div style="width: 33%; margin-top: 10px">
                  <div style="display: flex; padding: 0px" class="jfsj">
                    <span align="right" style="display: inline-block; width: 100px; line-height: 40px">执行申请：</span>
                    <el-select clearable v-model="listQuery.threeStepSettle" style="width: 70%; margin-left: 10px"
                      @change="handleFilter">
                      <el-option v-for="item in settleOptions" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div style="display: flex; justify-content: start">
                <div style="width: 33%; margin-top: 10px">
                  <div style="display: flex; padding: 0px" class="jfsj">
                    <span align="right" style="display: inline-block; width: 100px; line-height: 40px">执行结案：</span>
                    <el-select clearable v-model="listQuery.fourStepSettle" style="width: 70%; margin-left: 10px"
                      @change="handleFilter">
                      <el-option v-for="item in settleOptions" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <!-- 导出文书 -->
        <div style="">
          <el-dropdown @command="handleCommand">
            <el-button type="primary" size="small" style="margin-top: 10px"
              v-permission:function="['czSettle_Export_btn']">
              导出 <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu>
              <el-dropdown-item command="expSettleExcel"
                v-permission:function="['czCaseInfoManager_exp_settleExcel']">导出结算表</el-dropdown-item>
              <el-dropdown-item command="initData"
                v-permission:function="['czSettle_initData']">初始化数据</el-dropdown-item>
            </el-dropdown-menu>

          </el-dropdown>
        </div>
      </div>
    </template>

    <el-table :key="tableKey" :data="list" v-loading.body="listLoading" size="small" stripe highlight-current-row
      style="width: 100%">
      <el-table-column width="70px" align="center" label="编号">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column width="70px" align="center" label="案件ID">
        <template slot-scope="scope">
          <span>{{ scope.row.caseId }}</span>
        </template>
      </el-table-column>
      <el-table-column width="100px" align="center" label="批次号">
        <template slot-scope="scope">
          <span>{{ scope.row.batchId }}</span>
        </template>
      </el-table-column>
      <el-table-column width="130px" align="center" label="案号">
        <template slot-scope="scope">
          <span>{{ scope.row.registerCode }}</span>
        </template>
      </el-table-column>
      <el-table-column width="170px" align="center" label="当事人">
        <template slot-scope="scope">
          <el-link :underline="false" @click="showEditPage(scope.$index, scope.row)">
            <div style="font-size: 12px">{{ scope.row.plaintiffName }}</div>
          </el-link>
          <el-link type="primary" :underline="false" @click="showEditPage(scope.$index, scope.row)">
            <div>{{ scope.row.defendantName }}</div>
          </el-link>
        </template>
      </el-table-column>

      <el-table-column width="100px" align="center" label="委托日期">
        <template slot-scope="scope">
          <span>{{ scope.row.entrustmentDate }}</span>
        </template>
      </el-table-column>
      <el-table-column width="150px" align="center" label="主卡卡号">
        <template slot-scope="scope">
          <span>{{ scope.row.cardNum }}</span>
        </template>
      </el-table-column>
      <el-table-column width="140px" align="center" label="本金">
        <template slot-scope="scope">
          <div v-if="scope.row.principal !== undefined">
            <el-tag size="mini" type="success">本金{{ scope.row.principal }}</el-tag>
          </div>
          <div v-if="scope.row.totalBalance !== undefined">
            <el-tag size="mini" type="success">总余额：{{ scope.row.totalBalance }}</el-tag>
          </div>
        </template>
      </el-table-column>

      <el-table-column width="200px" align="center" label="日期">
        <template slot-scope="scope">
          <div v-if="scope.row.filingDate !== undefined">
            <el-tag size="mini" effect="plain">立案日期：{{ scope.row.filingDate }}</el-tag>
          </div>
           <div v-if="scope.row.medDate !== undefined">
            <el-tag size="mini" effect="plain">调解日期：{{ scope.row.medDate }}</el-tag>
          </div>
          <div v-if="scope.row.dropLawsuitRulingDate !== undefined">
            <el-tag size="mini" effect="plain">撤诉裁定日期：{{ scope.row.dropLawsuitRulingDate }}</el-tag>
          </div>
          <div v-if="scope.row.judDate !== undefined">
            <el-tag size="mini" effect="plain">判决日期：{{ scope.row.judDate }}</el-tag>
          </div>
         
          <div v-if="scope.row.executionDate !== undefined">
            <el-tag size="mini" effect="plain">执行日期：{{ scope.row.executionDate }}</el-tag>
          </div>
          <div v-if="scope.row.executedEndDate !== undefined">
            <el-tag size="mini" effect="plain">取得执行日期：{{ scope.row.executedEndDate }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="200px" align="center" label="结算情况">
        <template slot-scope="scope">
          <div v-if="scope.row.filingFee !== undefined">
            <el-tag size="mini" effect="plain" v-if="scope.row.filingFee == '已结'" type="success">第一阶段：{{
              scope.row.filingFee }}</el-tag>
            <el-tag size="mini" effect="plain" v-if="scope.row.filingFee == '未结'" type="danger">第一阶段：{{
              scope.row.filingFee }}</el-tag>
          </div>
          <div v-if="scope.row.judMedFee !== undefined">
            <el-tag size="mini" effect="plain" v-if="scope.row.judMedFee == '已结'" type="success">第二阶段：{{
              scope.row.judMedFee }}</el-tag>
            <el-tag size="mini" effect="plain" v-if="scope.row.judMedFee == '未结'" type="danger">第二阶段：{{
              scope.row.judMedFee }}</el-tag>
          </div>
          <div v-if="scope.row.executionFee !== undefined">
            <el-tag size="mini" effect="plain" v-if="scope.row.executionFee == '已结'" type="success">第三阶段：{{
              scope.row.executionFee }}</el-tag>
            <el-tag size="mini" effect="plain" v-if="scope.row.executionFee == '未结'" type="danger">第三阶段：{{
              scope.row.executionFee }}</el-tag>
          </div>
          <div v-if="scope.row.executionEndFee !== undefined">
            <el-tag size="mini" effect="plain" v-if="scope.row.executionEndFee == '已结'" type="success">第四阶段：{{
              scope.row.executionEndFee }}</el-tag>
            <el-tag size="mini" effect="plain" v-if="scope.row.executionEndFee == '未结'" type="danger">第四阶段：{{
              scope.row.executionEndFee }}</el-tag>
          </div>
        </template>
      </el-table-column>

      <el-table-column width="100px" align="center" label="代理人">
        <template slot-scope="scope">
          <span>{{ scope.row.agent }}</span>
        </template>
      </el-table-column>
      <el-table-column width="200px" align="center" label="数据统计日期">
        <template slot-scope="scope">
          <span>{{ scope.row.dataDate }}</span>
        </template>
      </el-table-column>
    </el-table>
    <template slot="footer">
      未结算案件数（当前条件下）：
      <el-tag type="danger">第一阶段{{ this.oneStep }}件</el-tag>
      <el-tag type="primary">第二阶段{{ this.twoStep }}件</el-tag>
      <el-tag type="warning">第三阶段{{ this.threeStep }}件</el-tag>
      <el-tag type="success">第四阶段{{ this.fourStep }}件</el-tag>
      <div v-show="!listLoading" class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </template>

    <!-- 预览案件 -->
    <el-dialog class="previewDialog" custom-class="heightFull" :title="'预览案件'" :visible.sync="isPreview" width="70%"
      center :close-on-click-modal="false">
      <Preview :caseId="this.id" v-if="isPreview"></Preview>
    </el-dialog>

    <el-dialog title="选择数据日期（不选默认当天）" :visible.sync="expSettleDataDialogVisible">
      <el-row>
        <el-radio-group v-model="CaseInfo.isWeiJie">
          <el-radio :label="true">仅导出未结清单</el-radio>
          <el-radio :label="false">导出全部清单</el-radio>
        </el-radio-group>
      </el-row>
      <el-row style="margin-top: 20px;">
        <el-date-picker v-model="CaseInfo.settleDataDate" type="date" placeholder="选择日期" format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"></el-date-picker>
      </el-row>
      <el-row style="margin-top: 20px;">
        <el-button style="height: 40px; width: 80px;" class="filter-item" type="primary"
          @click="expSettleExcel">确定</el-button>
      </el-row>
    </el-dialog>

  </d2-container>
</template>
<style scoped>
@import "../../../assets/style/CaseInfo/caseInfo.css";
</style>
<script>
import { page, initData } from "@/api/czManager/czSettlementData/index";
import { downLoadFile, downLoadExcel } from "@/plugin/axios";
import Preview from "@/pages/caseMediate/preview";
export default {
  name: "czSettlementData",
  components: {
    Preview,
  },
  data() {
    return {
      id: "",
      settleOptions: [
        {
          value: "已结",
          label: "已结",
        },
        {
          value: "未结",
          label: "未结",
        },
      ],
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        keyWord: undefined,
        oneStepSettle: "",
        twoStepSettle: "",
        threeStepSettle: "",
        fourStepSettle: "",
      },
      oneStep: "",
      twoStep: "",
      threeStep: "",
      fourStep: "",
      dialogFormVisible: false,
      dialogStatus: "",
      textMap: {
        update: "编辑",
        create: "创建",
      },
      tableKey: 0,
      isPreview: false,
      expSettleDataDialogVisible: false,
      CaseInfo: { settleDataDate: '', isWeiJie: true }
    };
  },
  created() {
    this.getList();
  },
  computed: {},
  methods: {
    getList() {
      this.listLoading = true;
      page(this.listQuery).then((response) => {
        this.list = response.czSettlementData.records;
        this.total = response.czSettlementData.total;
        this.oneStep = response.oneStep;
        this.twoStep = response.twoStep;
        this.threeStep = response.threeStep;
        this.fourStep = response.fourStep;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleCreate() {
      this.resetTemp();
      this.dialogStatus = "create";
      this.dialogFormVisible = true;
    },
    resetTemp() {
      this.listQuery = {
        page: 1,
        limit: 20,
        keyWord: "",
        oneStepSettle: "",
        twoStepSettle: "",
        threeStepSettle: "",
        fourStepSettle: "",
      };
      this.getList();
    },
    handleCommand(command) {
      console.log(command);
      if (command == "expSettleExcel") {
        this.expSettleDataDialogVisible = true;
        return;
      }
      if (command == "initData") {
        this.startInitData();
        return;
      }
    },
    /**
     * 导出结算表
     */
    expSettleExcel() {
      downLoadExcel(
        this,
        {
          requireSelect: true,
          isValidate: true,
          method: "post",
          url: "/api/case/czSettlementData/expSettleExcel",
        },
        (req) => {
          req.params = { settleDataDate: this.CaseInfo.settleDataDate };
          return req;
        }
      );
      return;
    },

    showEditPage(index, row) {
      console.log(row);
      this.id = row.caseId;
      this.isPreview = true;
      return;
    },
    startInitData() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      initData().then(res => {
        loading.close();
        this.$message({
          message: '成功',
          type: "success",
          duration: 5000,
        });

      }).catch(res => {
        loading.close();
        this.$message({
          message: res.message,
          type: "error",
          duration: 5000,
        });
      });
    }
  },
};
</script>
